export default "__VITE_ASSET__Cegslrot__"